// DetailsHelpers.js
export const getOrDash = (v, dash = "-") =>
  v === null || v === undefined || v === "" ? dash : v;

export const hasRealValue = (v) =>
  v !== null && v !== undefined && v !== "" && v !== "-";

export const formatDateTime = (ts) => {
  if (!ts) return "-";
  const d = new Date(ts);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${dd}/${mm}/${yy}, ${hh}:${mi}:${ss} Hrs`;
};

export const joinSizes = (sizesArr) =>
  Array.isArray(sizesArr) && sizesArr.length ? sizesArr.join(", ") : "-";

export const extractInitialSizeFromAssetName = (assetName) => {
  if (!assetName) return null;
  const str = String(assetName).trim();
  const m = str.match(/_(\d+)[×x](\d+)$/i);
  if (!m) return null;
  const w = Number(m[1]);
  const h = Number(m[2]);
  if (!Number.isFinite(w) || !Number.isFinite(h)) return null;
  return `${w}×${h}`;
};
